var map = {
	"./modulos/tarifas/tarifas.module": [
		"./src/app/modulos/tarifas/tarifas.module.ts",
		"default~modulos-tarifas-tarifas-module~modulos-usuario-usuario-module",
		"modulos-tarifas-tarifas-module"
	],
	"./modulos/usuario/usuario.module": [
		"./src/app/modulos/usuario/usuario.module.ts",
		"default~modulos-tarifas-tarifas-module~modulos-usuario-usuario-module",
		"modulos-usuario-usuario-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;